import gql from 'graphql-tag'


export const EXIST_ID = gql`
    mutation ($channelId:String!){
        existId(channelId:$channelId)
    }
`